





















































































































































import * as _ from 'lodash'
import moment from 'moment'
import urlTemplate from 'url-template'
import Vue from 'vue'
import { mapGetters, mapState } from 'vuex'

import clientList from '@/components/ClientList.vue'
import confirmDialog from '@/dialog/Confirm.vue'
import iconToggleButton from '@/elements/IconToggleButton.vue'
import miniFabButton from '@/elements/MiniFabButton.vue'
import optionAddDialog from '@/dialog/OptionAdd.vue'
import optionEditDialog from '@/dialog/OptionEdit.vue'
import propertyAddDialog from '@/dialog/PropertyAdd.vue'
import propertyEditDialog from '@/dialog/PropertyEdit.vue'
import propertyGroupAddDialog from '@/dialog/PropertyGroupAdd.vue'
import propertyGroupEditDialog from '@/dialog/PropertyGroupEdit.vue'
import radiobutton from '@/form/RadioButton.vue'
import sortable from '@/components/Sortable.vue'
import spinner from '@/elements/Spinner.vue'
import textfield from '@/form/Textfield.vue'
import toggableOptionList from '@/components/ToggableOptionList.vue'


setNewSortOrder = (collection, item, sortorder) ->
  collection[item.dataset.order].sortorder = sortorder
  collection[item.dataset.order]


export default
  name: 'PropertiesAdministration'
  data: () ->
    dialog: null
    show:
      confirm: false
      message: ''
      action: null
    toggle:
      groups: {}
      options: {}
    edit_group: {}
    add_to_group: {}
    edit_prop: {}
    edit_option: {}
    props_url_tmpl: null
    debug: false
    form: null
    types: [
      { label: 'Nummer', value: 'NUMBER' }
      { label: 'Sträng', value: 'STRING' }
      { label: 'Ja/Nej', value: 'BOOLEAN' }
      { label: 'Lista', value: 'ARRAY' }
    ]

  components:
    'v-dialog-property-group-edit': propertyGroupEditDialog
    'v-dialog-property-group-add': propertyGroupAddDialog
    'v-dialog-property-edit': propertyEditDialog
    'v-dialog-property-add': propertyAddDialog
    'v-dialog-option-add': optionAddDialog
    'v-dialog-option-edit': optionEditDialog
    'v-dialog-confirm': confirmDialog
    'v-textfield': textfield
    'v-client-list': clientList
    'v-fab-button': miniFabButton
    'v-toggable-option-list': toggableOptionList
    'v-icon-toggle-button': iconToggleButton
    'v-spinner': spinner

  directives:
    'sortable': sortable

  methods:

    ######  DIALOGS
    addGroup: () ->
      @$store.dispatch 'showDialog', 'add_group'

    addProperty: (group) ->
      @add_to_group = group
      @$store.dispatch 'showDialog', 'add_prop'

    addOption: (group, prop) ->
      @edit_group = group
      @edit_prop = prop
      @$store.dispatch 'showDialog', 'add_option'

    deleteGroup: (group) ->
      if group.getEmbeds('client_property_definition').length == 0
        @show.message = 'Säker på att du vill radera "' + group.name + '"?'
        @show.action = () =>
          @removeGroup(group)
      else
        @show.message = '"' + group.name + '" kan inte raderas - den innehåller egenskaper'
        console.log group.getEmbeds('client_property_definition')
        @show.action = () =>
          @cancel()
      @$store.dispatch 'showDialog', 'confirm'

    deleteProperty: (prop) ->
      @show.message = 'Säker på att du vill radera "' + prop.label + '"?'
      @show.action = () =>
        @removeProperty(prop)
      @$store.dispatch 'showDialog', 'confirm'

    deleteOption: (group, prop, option) ->
      @show.message = 'Säker på att du vill radera "' + option.value + '"?'
      @show.action = () =>
        @removeOption(option)
      @$store.dispatch 'showDialog', 'confirm'

    editGroup: (group) ->
      @edit_group = _.cloneDeep group
      @$store.dispatch 'showDialog', 'edit_group'

    editProperty: (prop) ->
      @edit_prop = _.cloneDeep prop
      @$store.dispatch 'showDialog', 'edit_prop'

    editOption: (group, prop, option) ->
      @edit_group = group
      @edit_prop = prop
      @edit_option = option
      @$store.dispatch 'showDialog', 'edit_option'

    ######  MISC
    toggleShowGroup: (idx) ->
      if @toggle.groups[idx]
        @$set @toggle.groups, idx, false
      else
        @$set @toggle.groups, idx, true

    toggleShowOptions: (idx) ->
      if @toggle.options[idx]
        @$set @toggle.options, idx, false
      else
        @$set @toggle.options, idx, true

    cancel: () ->
      @reset()

    reset: () ->
      @$store.dispatch 'showDialog', null
      reset =
        g: false
        p: false
        o: false

      @show.add = reset
      @show.edit = reset
      @show.confirm = false
      @edit_group = {}
      @edit_prop = {}
      @edit_option = {}

    ###### VUEX MESSAGES
    newGroup: (item) ->
      item.sortorder = @cprop_groups.getEmbeds('client_property_groups').length
      @$store.dispatch 'addGroup', item
      @reset()

    newProperty: (evt) ->
      @$store.dispatch 'addProperty', evt
      @reset()

    newOption: (evt) ->
      @$store.dispatch 'addOption', evt
      @reset()

    removeGroup: (group) ->
      @$store.dispatch 'deleteGroup', group
      @reset()

    removeProperty: (prop) ->
      @$store.dispatch 'deleteProperty', prop
      @reset()

    removeOption: (option) ->
      @$store.dispatch 'deleteOption', option
      @reset()

    updateGroup: (group) ->
      @$store.dispatch 'updateGroup', group
      @reset()

    updateProperty: (prop) ->
      @$store.dispatch 'updateProperty', prop
      @reset()

    updateOption: (evt) ->
      @$store.dispatch 'updateOption', evt
      @reset()

    reorderGroup: (order) ->
      groups = _.cloneDeep @cprop_groups.getEmbeds 'client_property_groups'

      new_groups = order.map (item, idx)->
        setNewSortOrder this, item, idx
      , groups

      @$store.dispatch 'updateGroups',
        groups: new_groups

    reorderProperty: (order, dataset) ->
      group = @cprop_groups.getEmbedByRelAndUID 'client_property_groups', dataset.g_uid
      props = _.cloneDeep group.getEmbeds 'client_property_definitions'

      new_props = order.map (item, idx) ->
        setNewSortOrder this, item, idx
      , props

      @$store.dispatch 'updateProps',
        group: group
        props: new_props

    reorderOption: (order, dataset) ->
      group = @cprop_groups.getEmbedByRelAndUID 'client_property_groups', dataset.g_uid
      prop = group.getEmbedByRelAndUID 'client_property_definitions', dataset.p_uid

      options = _.cloneDeep prop.getEmbeds 'client_property_option'

      new_options = order.map (item, idx) ->
        setNewSortOrder this, item, idx
      , options

      @$store.dispatch 'updateOptions',
        group: group
        prop: prop
        options: new_options

  created: () ->
    if !@are_loaded.resources then await @$store.dispatch 'getServices'
    if !@are_loaded.groups then await @$store.dispatch 'getGroups'

  mounted: () ->
    componentHandler.upgradeElements @$el

  beforeDestroy: ()->
    componentHandler.downgradeElements @$el

  computed: {
    mapGetters([
        'isLoaded'
    ])...
    mapState([
      'cprop_groups'
      'are_loaded'
    ])...
  }




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/administration/Properties.vue